import { ArticleSources } from 'types/studio/studio';
import { CustomPortableText } from 'shared/studio/PortableText';
import { Typography, Space, PlusToMinusIcon } from '@ag1/ui';
import { Collapse } from 'react-collapse';
import { useState } from 'react';
import styles from './EduArticleSources.module.scss';

export const EduArticleSources = ({ title, description }: ArticleSources) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <Space top={{ xxs: 16, s: 24 }} bottom={{ xxs: 16, s: 24 }} className={styles.border}>
      <div
        className={styles.accordeon}
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={handleKeyPress}>
        <Typography
          variant="subtitle"
          size="2"
          weight="700"
          color="black-new"
          component="h3"
          noPadding
          className={styles.title}>
          {title}
        </Typography>
        <PlusToMinusIcon isOpen={isOpen} className={styles.icon} />
      </div>

      <Collapse isOpened={isOpen}>
        <Typography
          variant="body"
          component="div"
          size="1"
          color="black-new"
          noPadding
          className={styles.description}>
          <CustomPortableText value={description} />
        </Typography>
      </Collapse>
    </Space>
  );
};
